export function formatAddress(fields) {
  return [
    fields.AREA,
    fields.CITY,
    fields.STREET,
    fields.BUILD,
    fields.ADDRESS,
    fields.BUILD_APART_NUM,
    fields.POSTINDEX,
  ]
    .filter(Boolean)
    .join(', ')
}

// Ключи профиля для улицы/дома различаются по стране (PL — отдельная схема).
function addressProfileKeys(countryCode) {
  return countryCode === 'PL'
    ? { streetKey: 'ADDRESS', buildKey: 'BUILD_APART_NUM' }
    : { streetKey: 'STREET', buildKey: 'BUILD' }
}

function pickComponentValue(component) {
  if (!component) return null
  if (component.long_name) return component.long_name
  if (component.short_name) return component.short_name
  return null
}

// Чистое извлечение адресных полей (улица/дом/индекс/координаты) из объекта
// Google Places.
export function extractCourierAddressFromGoogle(googleObj, countryCode) {
  const { streetKey, buildKey } = addressProfileKeys(countryCode)

  const result = {
    streetKey,
    streetValue: null,
    buildKey,
    buildValue: null,
    postindex: null,
    formatted: '',
    marker: null,
  }

  if (!googleObj || !Array.isArray(googleObj.address_components)) {
    return result
  }

  const components = googleObj.address_components
  const findByTypes = (...types) =>
    components.find(
      (field) =>
        Array.isArray(field.types) &&
        types.every((type) => field.types.includes(type))
    )

  // street: route → (KR) sublocality_level_4 → (CZ) neighborhood → fallback locality
  let street = findByTypes('route')

  if (!street && countryCode === 'KR') {
    street = findByTypes('sublocality_level_4')
  }

  // building: street_number → premise
  let building = findByTypes('street_number')
  if (!building) {
    building = findByTypes('premise')
  }

  if (!street && countryCode === 'CZ') {
    const streetName = findByTypes('neighborhood')
    street = { long_name: streetName?.long_name || null }
  }

  // фолбек: нет route, но есть дом — берём locality как улицу
  if (!street && building) {
    const fallbackStreet = findByTypes('locality', 'political')
    if (fallbackStreet) {
      street = {
        long_name: fallbackStreet.long_name || null,
        short_name: fallbackStreet.short_name || null,
      }
    }
  }

  const postalCode = findByTypes('postal_code')

  result.streetValue = pickComponentValue(street)
  result.buildValue = pickComponentValue(building)
  result.postindex = pickComponentValue(postalCode)
  result.formatted = googleObj.formatted_address || ''

  const location = googleObj.geometry?.location
  if (
    location &&
    typeof location.lat === 'function' &&
    typeof location.lng === 'function'
  ) {
    result.marker = { lat: location.lat(), lng: location.lng() }
  }

  return result
}
